module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/right-b94371d8e48e9ea070bb8e48d0f3cfe2.svg";